export default __webpack_public_path__ + "images/42eb9fd223af7fb94b408a21accf5907-houston_mobile.webp";